import { Link, useLocation } from 'react-router-dom';
import { ShoppingBag, X, List } from '@phosphor-icons/react';
import { useCart } from '../context/CartContext';
import { useState } from 'react';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '../components/ui/sheet';
import { Button } from '../components/ui/button';

export const Navbar = () => {
  const location = useLocation();
  const { getCartCount, setIsCartOpen } = useCart();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const navLinks = [
    { path: '/shop/men', label: 'SHOP' },
    { path: '/book', label: 'BUY BOOK' },
  ];

  return (
    <nav className="sticky top-0 z-50 bg-black border-b border-border" data-testid="navbar">
      <div className="px-6 md:px-12 lg:px-24">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link 
            to="/" 
            className="font-bold text-2xl tracking-tighter uppercase"
            data-testid="logo-link"
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            THREADS
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-${link.label.toLowerCase()}`}
                className={`text-xs tracking-[0.2em] font-bold uppercase transition-colors hover:text-primary ${
                  location.pathname === link.path ? 'text-primary' : 'text-muted-foreground'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Cart Button */}
          <div className="flex items-center gap-4">
            <button
              onClick={() => setIsCartOpen(true)}
              className="relative p-2 hover:text-primary transition-colors"
              data-testid="cart-button"
              aria-label="Open cart"
            >
              <ShoppingBag size={24} weight="bold" />
              {getCartCount() > 0 && (
                <span className="absolute -top-1 -right-1 bg-primary text-primary-foreground text-xs w-5 h-5 flex items-center justify-center font-bold">
                  {getCartCount()}
                </span>
              )}
            </button>

            {/* Mobile Menu Button */}
            <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
              <SheetTrigger asChild className="md:hidden">
                <Button variant="ghost" size="icon" data-testid="mobile-menu-button">
                  <List size={24} weight="bold" />
                </Button>
              </SheetTrigger>
              <SheetContent side="left" className="bg-black border-border w-full">
                <SheetHeader>
                  <SheetTitle className="text-left text-2xl tracking-tighter uppercase" style={{ fontFamily: "'Oswald', sans-serif" }}>
                    MENU
                  </SheetTitle>
                </SheetHeader>
                <div className="flex flex-col gap-6 mt-8">
                  {navLinks.map((link) => (
                    <Link
                      key={link.path}
                      to={link.path}
                      onClick={() => setMobileMenuOpen(false)}
                      data-testid={`mobile-nav-${link.label.toLowerCase()}`}
                      className={`text-2xl tracking-[0.1em] font-bold uppercase transition-colors hover:text-primary ${
                        location.pathname === link.path ? 'text-primary' : 'text-foreground'
                      }`}
                      style={{ fontFamily: "'Oswald', sans-serif" }}
                    >
                      {link.label}
                    </Link>
                  ))}
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </nav>
  );
};
